import React, { useState, useEffect } from "react";
import { getSingleOrdersDetailsForDeHub, changeDeHubOrderStatus } from "../../api/apiService";
import { ToastSuccess, ToastError } from "../../component/toast-notification";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { loader } from "../../Actions/index";
import Moment from "react-moment";
import { getAllOrderCancelReason } from "../../api/apiService";
import moment from "moment";
import { useParams, useHistory } from "react-router-dom";
import DeCardOrderProducts from "./DeCardOrderProducts";

const SingleOrderDetailsForDeHub = () => {
  const { orderId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const loaderDisplay = useSelector((store) => store.loaderDisplay);
  
  const [orderDetails, setOrderDetails] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [showCancelReason, setShowCancelReason] = useState(false);
  const [setReason, setSetReason] = useState('');
  const [showCancelText, setShowCancelText] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [allOrderCancelReasons, setAllOrderCancelReasons] = useState([]);

  useEffect(() => {
    userOrdersDetails();
  }, []);

  const handleModalShowHide = () => setModalShow(!modalShow);

  const userOrdersDetails = async () => {
    dispatch(loader(true));
    try {
      const response = await getSingleOrdersDetailsForDeHub(orderId);
      setOrderDetails(response.data.data);
    } catch (ex) {
      console.log(ex);
      ToastError(ex.message);
    } finally {
      dispatch(loader(false));
    }
  };

  const handleOrderStatus = (e) => {
    const status = e.target.value;
    setSelectedStatus(status);
    if (status === "canceled" || status === "hub-canceled") {
      setShowCancelReason(true);
      handleAllOrderCancelReasons();
    } else {
      setShowCancelReason(false);
    }
  };

  const handleCancelReasonChange = (e) => {
    const reason = e.target.value;
    setSetReason(reason);
    setCancelReason(reason);
    setShowCancelText(reason === 'other');
  };

  const handleCancelTextChange = (e) => {
    setCancelReason(e.target.value);
  };

  const handleOrderStatusUpdate = async () => {
    try {
      const currentTime = new Date();
      const note = `Order Cancel by Admin as per request by customer or hub ${moment(currentTime).format('DD-MM-YYYY h:mm:a')}`;
      
      await changeDeHubOrderStatus(orderId, selectedStatus, cancelReason, note);
      
      setModalShow(false);
      setShowCancelReason(false);
      userOrdersDetails();
      ToastSuccess("Order status updated successfully");
    } catch (ex) {
      console.log(ex);
      ToastError(ex.message);
    }
  };

  const handleAllOrderCancelReasons = async () => {
    const availableForAdmin = true;
    try {
      const response = await getAllOrderCancelReason(null, availableForAdmin);
      if (response?.data?.status === 200) {
        setAllOrderCancelReasons(response.data?.data || []);
      }
    } catch (error) {
      console.log(error);
      ToastError('Something went wrong, when fetching cancel reasons...');
    }
  };

  const navigateToUserDetails = (userId) => history.push(`/users-management/user-details/${userId}`);
  const navigateToOutletProducts = (outletId) => history.push(`/daily-essentials/hubs/single-hub?hubId=${outletId}`);

  if (!orderDetails) return null;

  return (
    <div className="row my-4">
      <div className="col-sm-8">
        <div className="category-container">
          <div className="user-order-container">
            <div className="d-flex justify-content-between align-items-center">
              <div 
                className="order-name-container"
                style={{ cursor: 'pointer', color: '#007bff' }}
                onClick={() => navigateToUserDetails(orderDetails.userId._id)}
              >
                <span>Order<br />by:</span>
                <h4 className="family-Courgette">
                  {orderDetails.userId?.full_name}
                  <br />({orderDetails.userId?.mobile})
                </h4>
              </div>
              
              {orderDetails.friendsOrFamily && (
                <div className="order-name-container" style={{ color: '#b615f3' }}>
                  <span>Order<br />for:</span>
                  <h4 className="family-Courgette">
                    {orderDetails.receiverName}
                    <br />({orderDetails.receiverMobile})
                  </h4>
                </div>
              )}
              
              {orderDetails.trackUrl && (
                <a href={orderDetails.trackUrl} target="_blank" rel="noopener noreferrer">
                  <button type="button" className="btn btn-outline-primary btn-sm">
                    Track order
                  </button>
                </a>
              )}
            </div>
            
            <address>
              <b>Pickup Address</b>: {orderDetails.pickUpAddress.address}
            </address>
            <address>
              <b>Delivery Address</b>: {orderDetails.deliveryAddress.address}
            </address>
            
            <div className="d-flex justify-content-between">
              <div className="w-50 p-2">
                <span><b>Date : </b><Moment format="DD-MM-YY HH:mm">{orderDetails.createdAt}</Moment></span>
                <br />
                <span><b>Order ID</b>: {orderDetails.orderId}</span>
                <br />
                <span><b>Order Type</b>: {orderDetails.orderType === 0 ? "Normal" : "Auction"}</span>
                <br />
                <span><b>Payment Mode</b>: {orderDetails.paymentMode}</span>
                <br />
                <span>
                  <b>Payment Status</b>: 
                  <span className="badge badge-success">{orderDetails.paymentStatus}</span>
                </span>
                <br />
                <span>
                  <b>Delivery Status</b>: 
                  {orderDetails.deliveryType === "take_away" ? "Take away" : orderDetails.deliveryStatus}
                </span>
                <br />
                <span>
                  <b>Order Status</b>: 
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={handleModalShowHide}
                    className={`text-capitalize badge ${
                      orderDetails.orderStatus === "completed" ? "badge-success" :
                      orderDetails.orderStatus === "preparing" ? "badge-primary" :
                      orderDetails.orderStatus === "ready-for-pickup" ? "badge-info" :
                      orderDetails.orderStatus === "out-for-delivery" ? "badge-secondary" :
                      orderDetails.orderStatus === "submitted" ? "badge-warning" : "badge-danger"
                    }`}
                  >
                    {orderDetails.orderStatus}<i className="fa fa-caret-down" style={{ paddingLeft: '5px' }} />
                  </span>
                  {(orderDetails.orderStatus === 'canceled' || orderDetails.orderStatus === 'outlet-canceled') && (
                    <>
                      <br />
                      <span><b>note</b>: <i className="no-data" style={{fontSize:'13px'}}>{orderDetails.note}</i></span>
                      <br />
                      <span><b>Cancel Reason</b>: <i className="no-data">{orderDetails.orderCancelReason}</i></span>
                    </>
                  )}
                </span>
              </div>
              
              <div className="w-50">
                <span><b>Tax</b>: {orderDetails.tax.toFixed(2)}</span>
                <br />
                <span><b>Discount</b>: {orderDetails.discount.toFixed(2)}</span>
                <br />
                <span><b>Delivery Charge</b>: {orderDetails.deliveryCharge.toFixed(2)}</span>
                <br />
                <span><b>Packaging Charge</b>: {orderDetails.packagingCharge.toFixed(2)}</span>
                <br />
                <span><b>Platform Charge</b>: {orderDetails.platformCharge?.toFixed(2) || '0.00'}</span>
                <br />
                <span><b>Total Amount</b>: <kbd>₹ {orderDetails.orderAmount.toFixed(2)}</kbd></span>
              </div>
              
              <div className="pr-4">
                <h1 className="m-0 text-center">₹</h1>
                <h1 className="m-0 text-center family-Courgette">
                  {orderDetails.orderAmount.toFixed(2)}
                </h1>
              </div>
            </div>
            
            {orderDetails.progressStatus && (
              <div className="my-sm-4">
                <h4 className="family-Courgette">Progress Status :</h4>
                <div className="details">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Stage</th>
                        <th>Time</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(orderDetails.progressStatus).map((key, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{orderDetails.progressStatus[key].typeText}</td>
                          <td>
                            <Moment format="DD-MM-YY || HH:mm">
                              {orderDetails.progressStatus[key].time}
                            </Moment>
                          </td>
                          <td>{orderDetails.progressStatus[key].state}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            
            <div className="my-sm-4">
              <h4 className="family-Courgette">Hub Details :</h4>
              <div className="details">
                <div className="d-flex">
                  <div className="food-img-sec">
                    <img
                      src={orderDetails.outletId.De_Hub_images}
                      className="addon-product-table-img"
                      alt=""
                    />
                  </div>
                  <div className="w-100">
                    <h4
                      style={{ cursor: 'pointer', color: '#007bff' }}
                      onClick={() => navigateToOutletProducts(orderDetails.outletId?._id)}
                    >
                      {orderDetails.outletId.hub_name}
                    </h4>
                    <div className="d-flex justify-content-between mb-2">
                      <div className="w-50">
                        <span><b>Phone no</b>: {orderDetails.outletId?.phone}</span>
                        <br />
                      </div>
                      <div className="w-50">
                        <span>
                          <b>Status</b>: 
                          <span className={`badge ${orderDetails.outletId?.isActive ? "badge-success" : "badge-danger"}`}>
                            {orderDetails.outletId?.isActive ? "Open" : "Close"}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="col-sm-4">
        {orderDetails.complementary?.name && (
          <div className="category-container">
            <b>Complementary Items:</b>
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: 'rgb(49, 124, 120)', fontSize: '16px' }}>
                    <b>{orderDetails.complementary.name}</b>
                  </td>
                  <td>
                    <span className="free-complementary">
                      {orderDetails.complementary.price.toFixed(2)}
                    </span>&nbsp;&nbsp;
                    <span style={{ color: 'rgb(49, 124, 120)' }}>0.00</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        
        <br />
        {orderDetails.foods.map((f) => (
          <React.Fragment key={f._id}>
            <DeCardOrderProducts title="Products :" data={f} />
            <br />
          </React.Fragment>
        ))}
        
        <p>
          <b style={{ color: 'rgb(49, 124, 120)' }}>Total Number of Items:&nbsp;&nbsp;</b>
          {orderDetails.foods.length}
        </p>
      </div>
      
      <Modal
        show={modalShow}
        onHide={handleModalShowHide}
        backdrop="static"
        size="sm"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Order Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <select
              onChange={handleOrderStatus}
              className="form-control"
              value={selectedStatus || orderDetails.orderStatus}
            >
              <option value={orderDetails.orderStatus} style={{ display: "none" }}>
                {orderDetails.orderStatus}
              </option>
              <option value="canceled">Canceled</option>
              <option value="hub-canceled">Hub Canceled</option>
              <option value="submitted">Submitted</option>
              <option value="getting-packed">Getting Packed</option>
              <option value="packed">Packed / waiting for pickup</option>
              <option value="out-for-delivery">Out for delivery</option>
              <option value="completed">Completed</option>
            </select>
          </div>
          
          {showCancelReason && (
            <div className="mt-3">
              <label>Select Cancellation Reason:</label>
              <select
                onChange={handleCancelReasonChange}
                className="form-control"
                value={setReason}
              >
                <option>--Select a reason--</option>
                {allOrderCancelReasons.map((reason) => (
                  <option key={reason.cancelReason} value={reason.cancelReason}>
                    {reason.cancelReason}
                  </option>
                ))}
                <option value="other">Other</option>
              </select>
            </div>
          )}
          
          {showCancelText && (
            <div className="mt-3">
              <label>Please provide the reason:</label>
              <textarea
                onChange={handleCancelTextChange}
                className="form-control"
                value={cancelReason}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn-verify" onClick={handleOrderStatusUpdate}>
            Update
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SingleOrderDetailsForDeHub;